import React from "react";
import { Route, Routes } from "react-router-dom";
import Application from "./Applications";
import Contact from "./Pages/Contact/Contact";
import Privacy from "./Pages/Privacy/Privacy"
import ServiceBC from "./Pages/ServiceBC/ServiceBc";
import ServiceDM from "./Pages/serviceDM/ServiceDM";
import Serviceweb from "./Pages/serviceWEB/Serviceweb";
import ServiceOM from "./Pages/serviceOM/ServiceOM";
import ServiceSB from "./Pages/serviceSB/ServiceSB";
import Course from "./Pages/Courses/Course";
import ServiceFB from "./Pages/ServiceFB/ServiceFB";
import BlogPage from "./Pages/BlogPage/BlogPage";
import BlogDetail from "./Pages/BlogDetail/BlogDetail"

export default function Links() {
    return (
        <>
            <Routes>
                <Route exact path="/" element={<Application />} />
                <Route exact path="/contactUs" element={<Contact />} />
                <Route exact path="/privacy" element={<Privacy />} />
                <Route exact path="/serviceBC" element={<ServiceBC />} />
                <Route exact path="/serviceDM" element={<ServiceDM />} />
                <Route exact path="/serviceWEB" element={<Serviceweb />} />
                <Route exact path="/serviceOM" element={<ServiceOM />} />
                <Route exact path="/serviceSB" element={<ServiceSB />} />
                <Route exact path="/serviceFB" element={<ServiceFB />} />
                <Route exact path="/Blog" element={<BlogPage />} />
                <Route path="/Blog/:slug" element={<BlogDetail />} />
                <Route exact path="/course" element={<Course />} />
            </Routes>
        </>
    )
}